import styled from 'styled-components';

export const Container = styled.div`
    height: 100vh;
    flex: 5;
    padding: 0.8rem 2rem;

    @media (max-width:750px) {
        width: 88%;
        padding: 0.4rem;
    }
`;
